import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getLinkDetails, updateArticlePost } from 'services/compose'
import { BulkContentPost } from 'services/compose/state'
import { StoreThunkDispatch } from 'store/state'

// Fetch at most once per url: the fetched details may still match the "needs details" condition
// (e.g. no description returned), and re-running on every article ref change would loop the request.
// Kept at module level because the virtualized list unmounts rows while scrolling - a per-instance
// ref would fetch again every time a row scrolls back into view.
const fetchedArticleUrls = new Set<string>()

/** Drops the fetched-urls cache - call it when the bulk composer unmounts. */
export function resetFetchedArticleUrls() {
  fetchedArticleUrls.clear()
}

/** Fills in a bulk article post's missing image/description from the link preview service. */
export function useArticleLinkDetails(post: BulkContentPost) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const { article } = post

  useEffect(() => {
    const url = article?.url
    if (!url || fetchedArticleUrls.has(url)) {
      return
    }
    if (!article.imageUrl || article.description?.startsWith('<div')) {
      fetchedArticleUrls.add(url)
      dispatch(getLinkDetails({ url }))
        .unwrap()
        .then((response: any) => {
          const link = response?.link
          const image = link?.image ? link.image[0] : null
          if (image) {
            dispatch(updateArticlePost({ id: post.id, article: { imageUrl: image, description: link.description || article.description } }))
          }
        })
        .catch(() => undefined)
    }
  }, [article, dispatch, post.id])
}
